export const isCadeteria = (userInfo) => {
    if (userInfo === null)
        return false
    else
        return userInfo.roles.find(rol => {
            if (rol.name == 'cadeteria') {
                return true
            }
        });

}